import React, { useEffect, useState } from 'react'
import apis from '../../api'

const useInfo = (page) => {

    const [info, setInfo] = useState([])
    const headers = { Authorization: localStorage.getItem("token") }

    useEffect(() => {
        const getMessages = async () => {
            await apis.getInfoMessages(page, headers).then(res => {
                let array = res.data[page]
                let data = []
                array.forEach(element => {
                    data.push(element.MESSAGE)
                });
                setInfo(data)
            })
        }
        getMessages()
    }, [])

    return {
        info
    }

}

export default useInfo
